import { createContext, useContext } from 'react';

export const LocationContext = createContext({
  activeLocation: null,
  setActiveLocation: () => {},
  allowedLocations: [],
});

export const useActiveLocation = () => useContext(LocationContext);
